module.exports = __webpack_public_path__ + "img/lg_ring_r_c_null_null@3x.4bff5be8.png";